module.exports = __webpack_public_path__ + "media/stylesheets/opensans400-53ea6dd630c9834ba13c5e79f898bd9c.woff2";